import { SonarRecord } from '@ui/records';
import { SonarText } from '@ui/text';
import { usePeriscopeActions } from '@hooks';
import { EmailAlertRecipientType, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
const visibleRecipientTypes = {
    [EmailAlertRecipientType.AccountTeam]: true,
    [EmailAlertRecipientType.CaseTeam]: true,
    [EmailAlertRecipientType.Role]: true,
    [EmailAlertRecipientType.RoleSubordinates]: true,
    [EmailAlertRecipientType.User]: true
};
const showRecipient = (type) => visibleRecipientTypes[type];
export const EmailAlertRecipientField = ({ record, parentIndex }) => {
    const { openPeriscope } = usePeriscopeActions();
    const handleClick = useCallback(() => {
        const { displayName, sonarObjectId } = record;
        openPeriscope({
            id: sonarObjectId,
            name: displayName,
            openedFromIndex: parentIndex,
            type: SonarObjectType.SalesforceField
        });
    }, [record, openPeriscope, parentIndex]);
    const handleParentClick = useCallback(() => {
        const { parentDisplayName, parentSonarObjectId } = record;
        openPeriscope({
            id: parentSonarObjectId,
            name: parentDisplayName,
            openLeft: true,
            openedFromIndex: parentIndex,
            type: SonarObjectType.SalesforceEntity
        });
    }, [record, openPeriscope, parentIndex]);
    const name = React.createElement(React.Fragment, null,
        React.createElement(SonarText, { weight: 'semibold' }, record.displayName),
        record.recipient && showRecipient(record.recipientType) && `: ${record.recipient}`);
    return (React.createElement(SonarRecord, { key: record.sonarObjectId, name: name, onClick: handleClick, onClickParent: handleParentClick, parentName: record.parentDisplayName, sonarObjectId: record.sonarObjectId, sonarObjectType: record.sonarObjectType }));
};
